// Library methods

// Utils
import { POST, GET } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_ADD_CHECKOUT_CUSTOMIZATION,
    API_ADD_CHECKOUT_CUSTOMIZATION_CUSTOM_DETAILS,
    API_GET_CHECKOUT_CUSTOMIZATION,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as checkoutAction from './checkout.actions';

// Constants
import {
    ADD_CHECKOUT_REQUEST,
    FETCH_CHECKOUT_REQUEST,
} from './checkout.constants';
import { takeLatest, put, call } from 'redux-saga/effects';

export function* getEntityInfo(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            merchantCode: payload,
        };
        const { data } = yield call(
            POST,
            API_GET_CHECKOUT_CUSTOMIZATION,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(checkoutAction.fetchCheckoutDetailsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                checkoutAction.fetchCheckoutDetailsError(data.errorMessage)
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(checkoutAction.fetchCheckoutDetailsError(data.errorMessage));
    }
    yield put(loaderActions.hideLoader());
}

export function* addCheckoutCustomization(actions) {
    try {
        const { payload } = actions;
        const themeRequest = { theme: payload.theme };

        const customizationRequestFormData = new FormData();

        customizationRequestFormData.append(
            'loader',
            payload.loader && payload.loader.length > 0
                ? payload.loader[0]
                : null
        );

        customizationRequestFormData.append(
            'headerLogo',
            payload.headerLogo && payload.headerLogo.length > 0
                ? payload.headerLogo[0]
                : null
        );

        customizationRequestFormData.append(
            'primaryColor',
            payload.primaryColor
        );

        const { data: otherDetailsResponseData } = yield call(
            POST,
            API_ADD_CHECKOUT_CUSTOMIZATION_CUSTOM_DETAILS,
            customizationRequestFormData,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );

        const { data: themeUpdateResponseData } = yield call(
            POST,
            API_ADD_CHECKOUT_CUSTOMIZATION,
            themeRequest
        );

        if (
            themeUpdateResponseData &&
            themeUpdateResponseData.statusCode === apiStatusCodes.SUCCESS2 &&
            otherDetailsResponseData &&
            otherDetailsResponseData.statusCode === apiStatusCodes.SUCCESS
        ) {
            yield put(
                checkoutAction.addCheckoutDetailsSuccess({
                    isLoading: false,
                    themeUpdateResponseData,
                    message: '',
                })
            );
        } else if (
            (themeUpdateResponseData && themeUpdateResponseData.errorMessage) ||
            (otherDetailsResponseData && otherDetailsResponseData.errorMessage)
        ) {
            yield put(
                checkoutAction.addCheckoutDetailsError(
                    themeUpdateResponseData.errorMessage
                        ? themeUpdateResponseData.errorMessage
                        : otherDetailsResponseData.errorMessage
                )
            );
        }
    } catch ({ response }) {
        const { data, status } = response;

        if (status !== 401) {
            yield put(
                checkoutAction.addCheckoutDetailsError(data.errorMessage)
            );
        }
    }
}

/**
 * WATCHER SAGA
 */
export function* checkoutSaga() {
    yield takeLatest(FETCH_CHECKOUT_REQUEST, getEntityInfo);
    yield takeLatest(ADD_CHECKOUT_REQUEST, addCheckoutCustomization);
}
